import { SpatialOption, spatialValuesInRem } from './spatialValues';

export type SpatialSquareInset = { [option in SpatialOption]: string };

/**
 * An inset offer indents content on all four sides - like the mat of a framed photo on a wall.
 * As such, it "pads" the inside of a container.
 *
 * The default value is a useful starting point for mobile first design - expanding to large
 * at a relevant viewport like `768px`.
 *
 * *Usage*: apply an inset value as padding.
 * `padding: spatialSquareInset.default`
 */
export const spatialSquareInset: SpatialSquareInset = {
  default: spatialValuesInRem.md, // '16px 16px 16px 16px',
  xs: spatialValuesInRem.xs, // '4px 4xp 4px 4px',
  sm: spatialValuesInRem.sm, // '8px 8px 8px 8px',
  md: spatialValuesInRem.md, // '16px 16px 16px 16px',
  lg: spatialValuesInRem.lg, // '32px 32px 32px 32px',
  xl: spatialValuesInRem.xl // '64px 64px 64px 64px'
};
